module.exports = __webpack_public_path__ + "img/ticketing-system-2-deskop.6073dbf7.png";